<template>
    <b-container fluid class="animated fadeIn">
        <h1>EXIBIR DÍVIDAS ENVIADAS PARA PROTESTO</h1>

        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna
                                    :fields="fields"
                                    :showColunms="showColunms"
                                    @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                    v-model="filtrarPor"
                                                    :show-labels="false"
                                                    :options="opcoesFiltro"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    track-by="id"
                                                    label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                            class="multiselect__single"
                                                            v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
                                            <the-mask
                                                    id="numeroDivida"
                                                    class="form-control"
                                                    v-model="filtro.numeroDivida"
                                                    :mask="['###############']"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                            <the-mask
                                                    id="cpfCnpj"
                                                    class="form-control"
                                                    v-model="filtro.cpfCnpj"
                                                    :mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
                                            <b-form-input v-model="filtro.cadicms" type="text" id="cadicms" maxlength="20" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Comarca:" label-for="comarcas" class="text-label">
                                            <multiselect
                                                    v-model="filtro.comarcas"
                                                    :show-labels="false"
                                                    :options="dados.comarcas"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="codComarca"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                  <span
                                                          class="multiselect__single"
                                                          v-if="values.length &amp;&amp; !isOpen"
                                                  >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
                                            <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte" maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                            <multiselect
                                                    v-model="filtro.tipoCredito"
                                                    :show-labels="false"
                                                    :options="dados.creditos"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="id"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                  <span
                                                          class="multiselect__single"
                                                          v-if="values.length &amp;&amp; !isOpen"
                                                  >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Início):" label-for="dataInscricaoInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataInscricaoInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Fim)" label-for="dataInscricaoFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataInscricaoFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 8).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Remessa (Início):" label-for="remessaInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.remessaInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Remessa (Fim)" label-for="remessaFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.remessaFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 9).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Confirmação:" label-for="confirmacao" class="text-label">
                                            <multiselect
                                                    v-model="filtro.confirmacao"
                                                    :show-labels="false"
                                                    :options="dados.confirmacoes"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="idString"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                            class="multiselect__single"
                                                            v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 10).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Retorno:" label-for="retorno" class="text-label">
                                            <multiselect
                                                    v-model="filtro.retorno"
                                                    :show-labels="false"
                                                    :options="dados.retornos"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="idString"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                            class="multiselect__single"
                                                            v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 11).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Confirmação (Início):" label-for="dataConfirmacaoInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataConfirmacaoInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Confirmação (Fim)" label-for="dataConfirmacaoFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataConfirmacaoFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 12).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Retorno (Início):" label-for="dataRetornoInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataRetornoInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Retorno (Fim)" label-for="dataRetornoFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataRetornoFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 13).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Pgto (Início):" label-for="dataPagamentoInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataPagamentoInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Pgto (Fim)" label-for="dataPagamentoFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataPagamentoFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 14).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Carta:" label-for="carta" class="text-label">
                                            <multiselect
                                                    v-model="filtro.carta"
                                                    :show-labels="false"
                                                    :options="dados.cartas"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    label="nome"
                                                    track-by="id"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                  <span
                                                          class="multiselect__single"
                                                          v-if="values.length &amp;&amp; !isOpen"
                                                  >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 15).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Carta (Início):" label-for="dataCartaInicial" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataCartaInicial"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data Carta (Fim)" label-for="dataCartaFinal" class="text-label">
                                            <b-form-input type="date" v-model="filtro.dataCartaFinal"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button variant="primary" class="fonte-branca" @click="filtrar">
                                                <i class="fa fa-search"></i> Pesquisar
                                            </b-button>
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas Enviadas para Protesto - Valor Total: <strong>R$ {{ configTable.valorTotal | currency }}</strong> &nbsp; Quantidade: <strong>{{ configTable.rows }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabela
                                        :resultado="resultado"
                                        :fields="fields"
                                        :configTable="configTable"
                                        @sortingChanged="consultar"
                                        @consultar="consultar" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <CompBotoesFooter
                        @exportCSV="exportCSV"
                        @voltar="voltar"
                        :loadCSV="loadCSV" />
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    import axios from 'axios'
    import CompBotoesFooter from '../../protesto/components/CompBotoesFooter'
    import CompPaginacao from '../../protesto/components/CompPaginacao'
    import CompExibirOcultarColuna from '../../protesto/components/CompBotaoExibirOcultarColuna'
    import CompTabela from './CompTabela'

    export default {
        name: 'ExibirExcluidasProtesto',
        components: {
            CompBotoesFooter,
            CompPaginacao,
            CompExibirOcultarColuna,
            CompTabela
        },
        data() {
            return {
                ano: null,
                mes: null,
                tipoConsulta: null,
                filtrarPor: [],
                opcoesFiltro: [
                    {
                        id: 1,
                        filtro: 'Número da Dívida'
                    },
                    {
                        id: 2,
                        filtro: 'CPF/CNPJ'
                    },
                    {
                        id: 3,
                        filtro: 'CAD ICMS'
                    },
                    {
                        id: 4,
                        filtro: 'Comarca'
                    },
                    {
                        id: 5,
                        filtro: 'Contribuinte'
                    },
                    {
                        id: 6,
                        filtro: 'Tipo de Crédito'
                    },
                    {
                        id: 7,
                        filtro: 'Data Inscrição'
                    },
                    {
                        id: 8,
                        filtro: 'Remessa'
                    },
                    {
                        id: 9,
                        filtro: 'Confirmação'
                    },
                    {
                        id: 10,
                        filtro: 'Retorno'
                    },
                    {
                        id: 11,
                        filtro: 'Data Confirmação'
                    },
                    {
                        id: 12,
                        filtro: 'Data Retorno'
                    },
                    {
                        id: 13,
                        filtro: 'Pgto'
                    },
                    {
                        id: 14,
                        filtro: 'Carta'
                    },
                    {
                        id: 15,
                        filtro: 'Data Carta'
                    }
                ],
                filtro: {
                    numeroDivida: null,
                    cpfCnpj: null,
                    cadicms: null,
                    comarcas: null,
                    contribuinte: null,
                    tipoCredito: null,
                    dataInscricaoInicial: null,
                    dataInscricaoFinal: null,
                    remessaInicial: null,
                    remessaFinal: null,
                    confirmacao: null,
                    retorno: null,
                    dataConfirmacaoInicial: null,
                    dataConfirmacaoFinal: null,
                    dataRetornoInicial: null,
                    dataRetornoFinal: null,
                    dataPagamentoInicial: null,
                    dataPagamentoFinal: null,
                    carta: null,
                    dataCartaInicial: null,
                    dataCartaFinal: null
                },
                dados: {
                    comarcas: [],
                    creditos: [],
                    confirmacoes: [],
                    retornos: [],
                    cartas: []
                },
                configTable: {
                    perPage: 100,
                    sortField: 'contribuinte',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    load: false,
                    valorTotal: 0.00
                },
                showColunms: [],
                fields: [],
                resultado: [],
                ultimaPesquisa: null,
                loadCSV: false
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            }
        },
        methods: {
            limparFiltro() {
                this.filtrarPor = [];
                this.filtro = {
                    numeroDivida: null,
                    cpfCnpj: null,
                    cadicms: null,
                    comarcas: null,
                    contribuinte: null,
                    tipoCredito: null,
                    dataInscricaoInicial: null,
                    dataInscricaoFinal: null,
                    remessaInicial: null,
                    remessaFinal: null,
                    confirmacao: null,
                    retorno: null,
                    dataConfirmacaoInicial: null,
                    dataConfirmacaoFinal: null,
                    dataRetornoInicial: null,
                    dataRetornoFinal: null,
                    dataPagamentoInicial: null,
                    dataPagamentoFinal: null,
                    carta: null,
                    dataCartaInicial: null,
                    dataCartaFinal: null
                };
                this.filtrar();
            },

            toggleColuna(i) {
                let ativo;
                if(this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.refreshConfigColunm(i, ativo)
            },

            async refreshConfigColunm(i, ativo) {
                const token = JSON.parse(this.$store.getters.getUser).access_token;

                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo: ativo,
                };
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            filtrar() {
                this.configTable.currentPage = 1;

                this.ultimaPesquisa = this.obterFiltro();

                this.consultar();
            },

            async consultar() {
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;
                this.loadingEnter();
                axios.post(`${urlApi}/v1/dashboardProtesto/consultar?page=${this.configTable.currentPage}` + this.escapePerPage() + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.ultimaPesquisa, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                    .then(response => {
                        this.resultado = response.data.resultado;
                        this.configTable.rows = response.data.rows;
                        this.configTable.valorTotal = response.data.valorTotal;
                    }).finally(() => {
                    this.loadingExit()
                })
            },

            async exportCSV() {
                const urlApi = process.env.VUE_APP_ROOT_API;

                if(this.configTable.rows == 0) {
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ["Não há registros a serem exportados."] });
                } else {
                    this.loadCSV = true;
                    const token = JSON.parse(this.$store.getters.getUser).access_token;
                    axios.post(`${urlApi}/v1/dashboardProtesto/exportarCsv?page=${this.configTable.currentPage}` + this.escapePerPage() + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.ultimaPesquisa, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    }).then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;

                        let pdfName;
                        if(this.tipoConsulta == 0) {
                            pdfName = 'DevolvidoAntesDoApontamento.csv';
                        } else if(this.tipoConsulta == 1) {
                            pdfName = 'DevolvidoAposApontamento.csv';
                        } else if(this.tipoConsulta == 2){
                            pdfName = 'CartaRetiradaOuProtestoIndevido.csv';
                        } else if(this.tipoConsulta == 3){
                            pdfName = 'ProtestoSustadoOuSuspensoJudicialmente.csv';
                        } else if(this.tipoConsulta == 4){
                            pdfName = 'Enviado.csv';
                        } else if(this.tipoConsulta == 5){
                            pdfName = 'Apontado.csv';
                        } else if(this.tipoConsulta == 6){
                            pdfName = 'Protestado.csv';
                        } else if(this.tipoConsulta == 7) {
                            pdfName = 'DividaPagaParceladaGuiaFepgeNaoEmitida.csv';
                        } else if(this.tipoConsulta == 8){
                            pdfName = 'DividaPagaParcelaNoTriduoDaeQuitado.csv';
                        } else if(this.tipoConsulta == 9){
                            pdfName = 'DividaPagaParcelaNoTriduoDaePendente.csv';
                        } else if(this.tipoConsulta == 10){
                            pdfName = 'CartaAnuenciaExpedida.csv';
                        } else if(this.tipoConsulta == 11) {
                            pdfName = 'DividaPagaParceladaGuiaFepgeEmitida.csv';
                        }

                        link.setAttribute('download', pdfName);
                        document.body.appendChild(link);
                        link.click();
                    }).finally(() => {
                        this.loadCSV = false
                    });
                }
            },

            voltar() {
                this.$router.push('/acompanhamento-protesto');
            },

            async obterConfiguracaoUsuario() {
                const urlApi = process.env.VUE_APP_ROOT_API;
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const funcionalidade = 'CDAsEnviadasProtesto';

                this.loadingEnter();
                axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    response.data.forEach((field, i) => {
                        if(field.ativo) {
                            this.showColunms.push(i);
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            sortable: true,
                            sortDirection: "desc",
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                })
            },
            
            loadingEnter() {
                this.configTable.load = true
            },
            
            loadingExit() {
                this.configTable.load = false
            },
            
            async listarComarcas() {
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.get(`${urlApi}/v1/comarca/listar/protesto`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                    .then(response => {
                        this.dados.comarcas = response.data
                })
            },

            async listarTipoCredito() {
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.get(`${urlApi}/v1/cdaDisponivelAjuizamento/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                    .then(response => {
                        this.dados.creditos = response.data
                })
            },

            async listarTipoCarta() {
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.get(`${urlApi}/v1/dashboardProtesto/listarTipoCarta`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                    .then(response => {
                        this.dados.cartas = response.data
                })
            },

            async listarConfirmacoes() {
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.post(`${urlApi}/v1/dashboardProtesto/confirmacoes`, this.obterFiltro(), {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }).then(response => {
                    this.dados.confirmacoes = response.data
                });
            },

            async listarRetornos() {
                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;

                axios.post(`${urlApi}/v1/dashboardProtesto/retornos`, this.obterFiltro(), {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }).then(response => {
                    this.dados.retornos = response.data
                });
            },

            escapePerPage() {
                if (this.configTable.perPage == 'Todos') {
                    return '';
                }
                return '&perPage='  + this.configTable.perPage
            },

            obterFiltro() {
                let filtro = {
                    mes: this.mes,
                    ano: this.ano,
                    dashboardProtestoTipo: this.tipoConsulta,
                    numeroDivida: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.numeroDivida : null,
                    cpfCnpj: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cpfCnpj : null,
                    cadicms: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.cadicms : null,
                    comarcas: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.comarcas : null,
                    contribuinte: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.contribuinte : null,
                    tipoCredito: (this.filtrarPor.filter(e => e.id == 6).length > 0) ? this.filtro.tipoCredito : null,
                    dataInscricaoInicial: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? (this.filtro.dataInscricaoInicial ? this.filtro.dataInscricaoInicial.toString() : null) : null,
                    dataInscricaoFinal: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? (this.filtro.dataInscricaoFinal ? this.filtro.dataInscricaoFinal.toString() : null) : null,
                    remessaInicial: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? (this.filtro.remessaInicial ? this.filtro.remessaInicial.toString() : null) : null,
                    remessaFinal: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? (this.filtro.remessaFinal ? this.filtro.remessaFinal.toString() : null) : null,
                    confirmacao: (this.filtrarPor.filter(e => e.id == 9).length > 0) ? this.filtro.confirmacao : null,
                    retorno: (this.filtrarPor.filter(e => e.id == 10).length > 0) ? this.filtro.retorno : null,
                    dataConfirmacaoInicial: (this.filtrarPor.filter(e => e.id == 11).length > 0) ? (this.filtro.dataConfirmacaoInicial ? this.filtro.dataConfirmacaoInicial.toString() : null) : null,
                    dataConfirmacaoFinal: (this.filtrarPor.filter(e => e.id == 11).length > 0) ? (this.filtro.dataConfirmacaoFinal ? this.filtro.dataConfirmacaoFinal.toString() : null) : null,
                    dataRetornoInicial: (this.filtrarPor.filter(e => e.id == 12).length > 0) ? (this.filtro.dataRetornoInicial ? this.filtro.dataRetornoInicial.toString() : null) : null,
                    dataRetornoFinal: (this.filtrarPor.filter(e => e.id == 12).length > 0) ? (this.filtro.dataRetornoFinal ? this.filtro.dataRetornoFinal.toString() : null) : null,
                    dataPagamentoInicial: (this.filtrarPor.filter(e => e.id == 13).length > 0) ? (this.filtro.dataPagamentoInicial ? this.filtro.dataPagamentoInicial.toString() : null) : null,
                    dataPagamentoFinal: (this.filtrarPor.filter(e => e.id == 13).length > 0) ? (this.filtro.dataPagamentoFinal ? this.filtro.dataPagamentoFinal.toString() : null) : null,
                    carta: (this.filtrarPor.filter(e => e.id == 14).length > 0) ? this.filtro.carta : null,
                    dataCartaInicial: (this.filtrarPor.filter(e => e.id == 15).length > 0) ? (this.filtro.dataCartaInicial ? this.filtro.dataCartaInicial.toString() : null) : null,
                    dataCartaFinal: (this.filtrarPor.filter(e => e.id == 15).length > 0) ? (this.filtro.dataCartaFinal ? this.filtro.dataCartaFinal.toString() : null) : null
                }

                if(this.tipoConsulta == 0) {
                    filtro.retornoConfirmacaoPresente = true;
                    filtro.dataAptPresente = false;
                } else if(this.tipoConsulta == 1) {
                    filtro.retornoSolucaoPresente = true;
                    filtro.dataAptPresente = true;
                    filtro.statusProtesto = [2,3,4,5,6,9,10];
                    filtro.cartaPresente = false;
                } else if(this.tipoConsulta == 2) {
                    filtro.tipoCarta = [0,2];
                } else if(this.tipoConsulta == 3) {
                    filtro.retornoConfirmacaoPresente = true;
                    filtro.dataAptPresente = true;
                    filtro.statusProtesto = [13,14];
                    filtro.cartaPresente = false;
                } else if(this.tipoConsulta == 4) {
                    filtro.statusProtesto = [1];
                    filtro.dataProtocoloPresente = false;
                    filtro.cartaPresente = false;
                } else if(this.tipoConsulta == 5) {
                    filtro.dataAptPresente = true;
                    filtro.dataProtocoloPresente = true;
                    filtro.cartaPresente = false;
                    filtro.retornoSolucaoPresente = false;
                } else if(this.tipoConsulta == 6) {
                    filtro.retornoSolucaoPresente = true;
                    filtro.dataPagamentoParcelamentoPresente = false;
                    filtro.statusProtesto = [8];
                    filtro.cartaPresente = false;
                } else if(this.tipoConsulta == 8) {
                    filtro.dataPagamentoParcelamentoPresente = true;
                    filtro.dataAptPresente = true;
                    filtro.ocorrencia = '1';
                    filtro.statusProtesto = [7];
                    filtro.cartaPresente = false;
                } else if(this.tipoConsulta == 9) {
                    filtro.dataPagamentoParcelamentoPresente = false;
                    filtro.dataAptPresente = true;
                    filtro.statusProtesto = [0,1,2,3,4,5,6,7,9,10,11,12,13,14];
                    filtro.ocorrencia = '1';
                    filtro.cartaPresente = false;
                } else if(this.tipoConsulta == 10) {
                    filtro.dataPagamentoParcelamentoPresente = true;
                    filtro.statusProtesto = [8,10,11];
                    filtro.tipoCarta = [1];
                } else if(this.tipoConsulta == 7 || this.tipoConsulta == 11) {
                    filtro.retornoSolucaoPresente = true;
                    filtro.dataPagamentoParcelamentoPresente = true;
                    filtro.statusProtesto = [8];
                    filtro.cartaPresente = false;
                }

                return filtro;
            }
        },
        created() {
            const dataAtual = new Date(this.$store.getters.getDataAcompanhamentoProtesto);

            this.ano = dataAtual.getFullYear();
            this.mes = dataAtual.getMonth() + 1;

            this.tipoConsulta = localStorage.getItem('tipoAcompanhamentoProtesto');

            this.listarComarcas();
            this.listarTipoCredito();
            this.listarTipoCarta();
            this.listarRetornos();
            this.listarConfirmacoes();
            this.filtrar();
            this.obterConfiguracaoUsuario();
        },

    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .fonte-branca {
        color: #FFF;
    }

    .fonte-branca:hover {
        color: #FFF;
    }

    .fonte-branca:active {
        color: #FFF !important;
    }

    .table-sub-item, .table-sub-item > th, .table-sub-item > td {
        background-color: rgb(237, 237, 238);
    }
</style>
